import { Injectable } from '@angular/core';
import { IDatasource, IGetRowsParams } from 'ag-grid-community';
import { filterGrid } from '../utils/filter/filters.utils';
import { FilterMap, FilterModel } from '../utils/filter/filter.utils';
import { ComparatorMap, sortGrid } from '../utils/sort/sort.utils';
import { SharedModule } from '../../shared.module';

@Injectable({ providedIn: SharedModule })
export class InfiniteScrollingService {
  public getDataSource(
    data: any[],
    filterMap: FilterMap[] = [],
    sortMap: ComparatorMap[] = [],
    callback?: (arg?) => unknown
  ): IDatasource {
    return {
      rowCount: undefined,
      getRows: (params: IGetRowsParams) => {
        const sortModel = params.sortModel.map((model) => ({
          ...model,
          comparator: sortMap.find(({ colId }) => colId === model.colId)
            .comparator,
        }));

        const filterModel: FilterModel[] = Object.keys(
          params.filterModel
        ).reduce((model, key) => {
          model.push({
            ...params.filterModel[key],
            ...filterMap.find(({ colId }) => colId === key),
          });
          return model;
        }, []);

        const gridRows = sortGrid(
          filterGrid([...(data || [])], filterModel),
          sortModel
        );
        const blockRows = gridRows.slice(params.startRow, params.endRow);

        let lastRow = -1;
        if (gridRows.length <= params.endRow) {
          lastRow = gridRows.length;
        }
        params.successCallback(blockRows, lastRow);
        if (callback) {
          callback(gridRows);
        }
      },
    };
  }
}
